import fr from 'facet-rest';
import Text from 'Components/ComponentLibrary/Atoms/Text';

export default fr.metaOverride()
  .overrideAll({
    _hideLabel: true,
  }, { ordinal: 200 })
  .nameOverride('title', {
    _component: () => Text,
    _customProps: {
      variant: 'h2',
      weight: 'medium',
      color: 'darkGray',
      align: 'left',
    },
  }, { ordinal: 201 })
  .nameOverride('subtitle', {
    _component: () => Text,
    _customProps: {
      variant: 'h4',
      weight: 'light',
      color: 'darkGray',
      align: 'left',
    },
  }, { ordinal: 201 });
